import {Injectable, EventEmitter} from '@angular/core';
import {Location} from '@angular/common';

@Injectable()
export class FooterNavbarService {
    public prev$: EventEmitter<any>;
    public skip$: EventEmitter<any>;
    public next$: EventEmitter<any>;

    constructor(private location: Location) {
        this.prev$ = new EventEmitter();
        this.skip$ = new EventEmitter();
        this.next$ = new EventEmitter();
    }

    prev() {
        this.location.back();
    }

    skip() {
        this.skip$.emit();
    }

    next() {
        this.next$.emit();
    }
}



// WEBPACK FOOTER //
// ./src/app/services/connectors/footer-navbar.service.ts